module.exports = __webpack_public_path__ + "static/media/1POLICY15.3bd9feb1.jpg";